import type { FaireProductEntity } from "../../entity_types/product";

export const p_qeu3z566u3: FaireProductEntity = {
  token: "p_qeu3z566u3",
  type: "product",
  name: "Embroidered Boyfriend Socks (Wholesale)",
  brandToken: "b_85a3118wke",
  brandName: "Le Bon Shoppe",
  imageUrl:
    "https://cdn.faire.com/fastly/44247c9959feafaf3773f502836d1acb8b160a07fc016464d4e48445d200513d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c491923c4b4dcca07d95accd69f558c04c11fe91d600710eea8ef9bc55ba0ff5.jpeg",
    "https://cdn.faire.com/fastly/c7e0505c5b7687faffd9c893d8b1344577176fb01c90ca5d6ad160893db43db9.jpeg",
    "https://cdn.faire.com/fastly/6a10772ff866f27178c9b5f47599e69f6782350d74fd698635eff10158cfeeab.jpeg",
    "https://cdn.faire.com/fastly/f6712402b0897b075e7a6ee68cda925b26fc89f1d3d7f8ea78e55be022a3929d.jpeg",
    "https://cdn.faire.com/fastly/cc3cc9f9aa00846265a0ca56e66da7a3d05af7f0f189c7d3e9b7dbde49f8b981.jpeg",
    "https://cdn.faire.com/fastly/e7d070bb4fd42c7482acc92eea6e33283a1c97c7c792601e92be58836445ea86.jpeg",
    "https://cdn.faire.com/fastly/1f36dac237222e5cd7fb898b620b498348cbd2e809c605285c12fff609000c89.jpeg",
    "https://cdn.faire.com/fastly/2aef73b592505d3ff8f6f5215f7c3d431ef1b00f2cf2218afa3544058467eef7.jpeg",
  ],
  priceDollars: 7,
  description:
    "𝐖𝐡𝐲 𝐖𝐞 𝐌𝐚𝐝𝐞 𝐓𝐡𝐢𝐬?\n\nThe classic Boyfriend socks you know and love, now with a little extra love. This year-round best seller maintains the perfect mix of function and fashion, creating an effortless sporty vintage charm to any outfit. It's slightly longer than a classic crew and has a contrast double stripe. A fun, embroidered heart sits just below the stripes for an endearing touch, making them the perfect pair to gift or soak up all the love in yourself.\n\nMade in South Korea\n\n𝐂𝐨𝐧𝐭𝐞𝐧𝐭𝐬:\n\n85 Cotton 13 Polyester 2 Spdx\n\n𝐒𝐢𝐳𝐢𝐧𝐠:\n\nOne size fits most (US women's size 6-10)\n\n𝐂𝐚𝐫𝐞 𝐈𝐧𝐬𝐭𝐫𝐮𝐜𝐭𝐢𝐨𝐧𝐬:\n\n• Machine wash cold\n• Tumble dry low\n• Do not iron\n• Do not bleach\n\n***Order in units of 6 (6,12,18,24 etc)\n\nMSRP: $16 USD",
  tags: [],
  msrpDollars: 16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-21T21:51:49.812Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
